'use client';

import { ThemeProvider as NextThemesProvider } from 'next-themes';

/**
 * Wraps the application with next-themes.
 * The `suppressHydrationWarning` on <html> in layout.js prevents
 * hydration mismatch warnings caused by next-themes' blocking script.
 * @param {{ children: React.ReactNode }} props
 */
export function ThemeProvider({ children }) {
  return (
    <NextThemesProvider
      attribute="class"
      defaultTheme="system"
      enableSystem
      disableTransitionOnChange
    >
      {children}
    </NextThemesProvider>
  );
}